/**
 * 站点资料请求类
 */
import request from '@/utils/request'

export function getPage(condition, pagination) {
  return request({
    url: '/crm/deliver/page',
    method: 'post',
    data: { condition: condition, pagination: pagination }
  })
}

export function deleteById(id) {
  return request({
    url: '/crm/deliver/deleteById',
    method: 'post',
    data: { id: id }
  })
}
export function saveOrUpdate(data) {
  return request({
    url: '/crm/deliver/saveOrUpdate',
    method: 'post',
    data
  })
}
/**
 * 获取详情
 * @param id
 * @returns {AxiosPromise}
 */
export function get(id) {
  return request({
    url: '/crm/deliver/get',
    method: 'get',
    params: {id: id }
  })
}

export function submit(id) {
  return request({
    url: '/crm/deliver/submit',
    method: 'post',
    data: { id: id }
  })
}

export function deliverLineList(id) {
  return request({
    url: '/crm/deliver/line/deliverLineList',
    method: 'post',
    data: { deliverId: id }
  })
}


export function getPageList(condition, pagination) {
  console.log(condition, pagination,'88888888888888888')
  return request({
    url: '/crm/deliver/salesOrderPage',
    method: 'post',
    data: { condition: condition, pagination: pagination }
  })
}
